import { render, staticRenderFns } from "./ResourceDetailsAttachmentSection.vue?vue&type=template&id=1f9862d6"
import script from "./ResourceDetailsAttachmentSection.vue?vue&type=script&lang=js"
export * from "./ResourceDetailsAttachmentSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports